import CrudCustom from '../../../libs/custom/CrudCustom';


let MigrasiTranskripService = new CrudCustom('/migrasi-transkrips');
export default MigrasiTranskripService;
